import React, { Fragment, useState, useContext, useEffect } from "react";

import { UrlServicesContext } from "components/UrlServicesContext";
import { makeStyles } from "@material-ui/core/styles";

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import axios from "axios";
import Skeleton from "@material-ui/lab/Skeleton";

import Form1 from "views/Form/Form1";
import Form2 from "views/Form/Form2";
import Form3 from "views/Form/Form3";
import logo from "assets/img/logo192.png";
import alert from "assets/img/undraw_Questions_re_1fy7.png";

import { cardStyle } from "assets/jss/material-dashboard-react/components/cardStyle";

const useStyles = makeStyles(cardStyle);

export default function FormPublic(props) {
  const classes = useStyles();

  const [sendView, setsendView] = useState(false);
  const [loader, setloader] = useState(true);

  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    let params = props.match.params.id;

    axios
      .get(`${urlServices}stakeholder-profiles/share/${params}`, {
        headers: {
          application: keyAplication,
        },
      })
      .then((response) => {
        setloader(false);

        switch (response.data.profile_id) {
          case "1":
            return setsendView(<Form1 />);
          case "2":
            return setsendView(<Form2 />);
          case "3":
            return setsendView(<Form3 />);
          default:
            return setsendView(
              <div className={classes.titleCard}>
                <img
                  src={alert}
                  alt="validate"
                  style={{
                    width: 300,
                    height: 220,
                    objectFit: "cover",
                  }}
                />
                <br></br>
                "No hay formulario que mostrar"
              </div>
            );
        }
      });
  }, [urlServices, keyAplication]);

  return (
    <Fragment>
      <GridContainer>
        <GridItem xs={12} md={12}>
          <center>
            <GridItem xs={12} md={8}>
              <Card>
                <center>
                  <img
                    src={logo}
                    alt="validate"
                    style={{
                      marginTop: 20,
                      width: 140,
                      height: 90,
                      objectFit: "cover",
                    }}
                  />
                </center>
                {loader ? (
                  <CardBody style={{ height: 800 }}>
                    <center>
                      <Skeleton width={300} height={50} />
                      <Skeleton variant="rect" width="90%" height={300} />
                    </center>
                  </CardBody>
                ) : (
                  <CardBody>{sendView}</CardBody>
                )}
              </Card>
            </GridItem>
          </center>
        </GridItem>
      </GridContainer>
    </Fragment>
  );
}
